import { AxiosInstance } from "axios";
import ReservationDependenciesModel from "models/dependencies/ReservationDependenciesModel";

export const getAll =
  (axios: AxiosInstance) => async (): Promise<ReservationDependenciesModel> => {
    return await axios
      .get("settings/dependencies/reservation")
      .then(({ data }) => data);
  };
